import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { DocumentStatus } from '@app/modules/documents/models/document.model';
import { DocumentsService } from '@app/modules/documents/services/documents.service';
import { FormElement } from '@app/modules/form-generator/edit-form-v3/models/form.model';
import { PagedData } from '@app/modules/lookup/models/paged-data.model';
import { from, Observable } from 'rxjs';

@Component({
  selector: 'app-document-status-form-field',
  templateUrl: './document-status-form-field.component.html',
  styleUrls: ['./document-status-form-field.component.scss']
})
export class DocumentStatusFormFieldComponent implements OnInit {
  @Input() formElement: FormElement;
  @Input() parentGroup: UntypedFormGroup;
  @Input() readOnly: boolean;
  isLoading: boolean;
  user$: any;
  filterString: string;
  options: Observable<PagedData<DocumentStatus>>;
  
  constructor(
    private documentsService: DocumentsService,
  ) { }

  ngOnInit(): void {
    this.options = from(this.documentsService.getDocumentStatuses(100, 0))
  }


}
